import React from "react";
import { Accordion } from "react-bootstrap";

export default function FaqPage() {
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            What is Dox and Box and how does it help businesses?
          </Accordion.Header>
          <Accordion.Body>
            Dox and Box is a document management and workflow automation platform that helps businesses securely store, organize, access their documents. It streamlines manual processes, improves collaboration, ensures compliance by centralizing information, enabling faster decision-making, enhancing overall operational efficiency across departments.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            What types of documents can be managed using Dox and Box?
          </Accordion.Header>
          <Accordion.Body>
            Dox and Box supports a wide range of documents including contracts, invoices, employee records, customer files, reports, more. It enables businesses to manage both physical and digital documents, ensuring they are securely stored, properly indexed, easily retrievable whenever required.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>
            How does Dox and Box ensure data security and compliance?
          </Accordion.Header>
          <Accordion.Body>
            Dox and Box uses advanced security measures such as encryption, role-based access controls, audit trails, secure archiving. These features ensure that sensitive information is protected while helping organizations comply with regulatory standards and maintain complete control over document access and usage.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>
            Can Dox and Box integrate with existing business systems?
          </Accordion.Header>
          <Accordion.Body>
            Yes, Dox and Box is designed to integrate seamlessly with existing business systems such as ERP, CRM, HRMS platforms. This allows organizations to streamline workflows, eliminate data silos, ensure smooth information flow across different departments without disrupting current processes.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>
            Is Dox and Box suitable for small and mid-sized businesses?
          </Accordion.Header>
          <Accordion.Body>
            Absolutely. Dox and Box offers scalable solutions that cater to businesses of all sizes. Small and mid-sized businesses can benefit from its easy-to-use interface, quick deployment, cost-effective features, helping them improve efficiency, reduce manual work, scale operations as they grow.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>
            How does workflow automation improve business efficiency?
          </Accordion.Header>
          <Accordion.Body>
            Workflow automation eliminates repetitive manual tasks by digitizing processes such as approvals, document routing, data entry. This reduces errors, speeds up operations, allows teams to focus on strategic work, ultimately improving productivity and ensuring faster turnaround times across business functions.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="6">
          <Accordion.Header>
            Can employees access documents remotely using Dox and Box?
          </Accordion.Header>
          <Accordion.Body>
            Yes, Dox and Box provides secure, cloud-based access to documents, enabling employees to retrieve, share, manage files from anywhere. This supports remote and mobile work environments, ensuring uninterrupted productivity while maintaining strict data security and access controls.
          </Accordion.Body>
        </Accordion.Item>


          <Accordion.Item eventKey="7">
          <Accordion.Header>
            How does Dox and Box help with audit readiness?
          </Accordion.Header>
          <Accordion.Body>
            Dox and Box maintains structured document storage with complete audit trails, version control, secure archiving. This ensures all records are easily accessible and properly maintained, helping organizations stay audit-ready at all times and simplifying internal and external audit processes.
          </Accordion.Body>
        </Accordion.Item>


          <Accordion.Item eventKey="8">
          <Accordion.Header>
            What are the key benefits of digitizing document management?
          </Accordion.Header>
          <Accordion.Body>
           Digitizing document management reduces reliance on paper, lowers storage costs, improves accessibility. It enables faster document retrieval, enhances collaboration, ensures data security, streamlines workflows, allowing businesses to operate more efficiently and make informed decisions with real-time information.
          </Accordion.Body>
        </Accordion.Item>


          <Accordion.Item eventKey="9">
          <Accordion.Header>
            How quickly can a business implement Dox and Box?
          </Accordion.Header>
          <Accordion.Body>
           Dox and Box offers flexible deployment options, including cloud-based solutions that can be implemented quickly. With pre-configured workflows and easy integration capabilities, businesses can start managing documents and automating processes in a short time, ensuring minimal disruption and faster return on investment.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}
